var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 7H5.83333H24.5",
    stroke: "#343434",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3335 7.00065V4.66732C9.3335 4.04848 9.57933 3.45499 10.0169 3.0174C10.4545 2.57982 11.048 2.33398 11.6668 2.33398H16.3335C16.9523 2.33398 17.5458 2.57982 17.9834 3.0174C18.421 3.45499 18.6668 4.04848 18.6668 4.66732V7.00065M22.1668 7.00065V23.334C22.1668 23.9528 21.921 24.5463 21.4834 24.9839C21.0458 25.4215 20.4523 25.6673 19.8335 25.6673H8.16683C7.54799 25.6673 6.9545 25.4215 6.51691 24.9839C6.07933 24.5463 5.8335 23.9528 5.8335 23.334V7.00065H22.1668Z",
    stroke: "#343434",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3335 12.834V19.834",
    stroke: "#343434",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 12.834V19.834",
    stroke: "#343434",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.a1e6b1cc3d0c0e3413a6cc8643204bfd.svg";
export { ForwardRef as ReactComponent };